import { ILogService } from 'angular'
import { CVModel } from 'src/_candidato/data/cv/CVModel'
import { $candidatoPublicMod } from 'src/_candidato/public/candidato-public-mod'
import { ICuestionario, IICuestionarioBloque, IICuestionarioPreg } from '../../../../model/candidato-api'

class StartBloqueComponentCtrl {
  bloque!: IICuestionarioBloque<IICuestionarioPreg>
  cuestionario!: ICuestionario
  cvmodel!: CVModel
  params!: { [v: string]: any }

  constructor(private $log: ILogService) {}

  $onInit(): void {
    this.$log.info('[StartBloqueComponentCtrl] onInit')
  }
}

export default $candidatoPublicMod.component('startBloque', {
  bindings: {
    bloque: '<',
    cuestionario: '<',
    cvmodel: '<',
    params: '<',
  },
  controller: StartBloqueComponentCtrl,
  template: require('./start-bloque.component.html'),
  //templateUrl: "../../../../app/ui/vs/prog/dev/templates/start-bloque/start-bloque.component.html"
})
